import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AddPropertyDialog({ open, onOpenChange, onSubmit, initial = null }) {
  const [name, setName] = useState("");
  const [tenantName, setTenantName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setName(initial?.name || "");
    setTenantName(initial?.tenant_name || "");
  }, [initial, open]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    await onSubmit({ name: name.trim(), tenant_name: tenantName.trim() });
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="property-dialog">
        <DialogHeader>
          <DialogTitle className="font-medium tracking-tight">
            {initial ? "Edit property" : "New property"}
          </DialogTitle>
          <DialogDescription className="text-stone-500">
            Give this property a name and the tenant who lives there.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="p-name">Property name</Label>
            <Input id="p-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Sunrise Apt 302" required data-testid="property-name-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="p-tenant">Tenant name</Label>
            <Input id="p-tenant" value={tenantName} onChange={(e) => setTenantName(e.target.value)} placeholder="e.g. Rohan Mehta" data-testid="property-tenant-input" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="property-dialog-cancel">Cancel</Button>
            <Button type="submit" disabled={saving} className="bg-emerald-900 hover:bg-emerald-800 text-stone-50" data-testid="property-dialog-save">
              {saving ? "Saving…" : initial ? "Save changes" : "Create property"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
